import React, {useState, useEffect, useRef, useCallback} from 'react';
import Tooltip from '../tooltip/Tooltip';
import CompanyListItem from './companyListItem/CompanyListItem';
import CompanyListItemLarge from './companyListItem/CompanyListItemLarge';
import useWindowSize from './search/windowResize';

function CompanyList({ companies }) {
    const size = useWindowSize();
    const [openSafeNo, setOpenSafeNo] = useState(false);
    const [openReg, setOpenReg] = useState(false);
    const [tooltipClassReg, setTooltipClassReg] = useState("more_info-list");
    const [tooltipClassSafeNo, setTooltipClassSafeNo] = useState("more_info-list");

    const span1 = useRef();
    const span2 = useRef();

    const handleClick = useCallback(e => {
        if(size.width >= 820) {
            if (span1.current.contains(e.target)) {
                setOpenReg(true)
                setTooltipClassReg("more_info-active")
                setTooltipClassSafeNo("more_info-list")
                setOpenSafeNo(false)
                return;
            } else if(span2.current.contains(e.target)) {
                setOpenSafeNo(true)
                setTooltipClassSafeNo("more_info-active")
                setOpenReg(false)
                setTooltipClassReg("more_info-list")
                return;
            } 
        }
        setOpenReg(false)
        setTooltipClassReg("more_info-list")
        setTooltipClassSafeNo("more_info-list")
        setOpenSafeNo(false);
    }, [size, span1, span2, setOpenReg, setTooltipClassSafeNo, setTooltipClassReg, setOpenSafeNo]);

    useEffect(() => {
        document.addEventListener("mousedown", handleClick);
        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
    }, [handleClick]);

    return (
        <>
            {size.width >= 820
                ?
                    <>           
                        <div className="list-divider-large"></div>
                        <div className="largeCompanyList_container">
                            <p><b>Company name</b></p>
                            <p><b>Org No</b><span ref={span1} className={tooltipClassReg}
                                onClick={handleClick}
                            >                  
                                {openReg && (
                                    <Tooltip title="Organisation number" text="The company's organisation number in official company/VAT registry for the country."/>
                                )}
                            </span></p>

                            <p><b>Connect ID</b><span ref={span2} className={tooltipClassSafeNo}
                                onClick={handleClick}
                            > 
                                {openSafeNo && (
                                    <Tooltip title="Connect ID" text="The Connect ID is a unique number that identifies business entities on a location-specific basis. Assigned and maintained by Creditsafe, the Connect ID is widely used as a standard business identifier."/>
                                )}
                            </span></p>
                            <p><b>Address</b></p>
                        </div>
                        <div className="list-divider-large-middle"></div>
                        <div className="company-list_container">
                            {companies.map((company, key)=> {
                                return (
                                    <CompanyListItemLarge key={key} company={company} />
                                )
                            })}
                        </div>
                    </>
                : 
                    <div className="company-list_container">
                        {companies.map((company,key)=> {
                            return (
                                <CompanyListItem key={key} company={company} />
                            )
                        })}
                    </div>
            }
        </>
    );
}

export default CompanyList;
